export const MEMBER_TYPE_FREE = 0;
export const MEMBER_TYPE_XXL = 2;

export const MEMBER_TYPE_TEXT = {
    [MEMBER_TYPE_FREE]: 'Free',
    [MEMBER_TYPE_XXL]: 'XXL'
};


// WEBPACK FOOTER //
// ./src/constants/memberTypes.js